<template>
  <feature-flag name="enable-new-appointments-table">
    <template #enabled>
      <appointments-page-v-2 />
    </template>
    <template #disabled>
      <appointments-page-v-1 />
    </template>
  </feature-flag>
</template>

<script>
/**
 * Appointments page
 * @displayName Appointments Page
 */
export default {};
</script>
